module.exports = __webpack_public_path__ + "img/sal_no.2da02123.png";